import { StyleSheet, Text, View } from "react-native";
import React from "react";
import PictureCard from "./PictureCard";
import { useAppSelector } from "../hooks/reduxHooks";
import { Button } from "react-native-paper";

const UserInformationCard = () => {
	const user = useAppSelector(s => s.auth.subUser);
	return (
		<View style={styles.root}>
			<PictureCard />
			<View style={styles.info}>
				<Text style={styles.greeting}>
					Olá,
					<Text style={{ fontWeight: "bold" }}>
						{" "}
						{user?.name.split(" ")[0]}
					</Text>
				</Text>
				<Button
					mode="contained"
					labelStyle={styles.btnLabel}
					style={styles.btn}
				>
					{user?.position}
				</Button>
			</View>
		</View>
	);
};

export default UserInformationCard;

const styles = StyleSheet.create({
	root: {
		width: "90%",
		height: 120,
		marginHorizontal: "5%",
		backgroundColor: "#fff",
		shadowColor: "#000",
		shadowOffset: {
			width: 0,
			height: 2,
		},
		shadowOpacity: 0.25,
		shadowRadius: 3.84,
		elevation: 5,
		borderRadius: 17,
		marginTop: 12,
		marginBottom: 16,
		flexDirection: "row",
		paddingLeft: 15,
		alignItems: "center",
	},
	greeting: {
		marginTop: 16,
		fontSize: 18,
		marginBottom: 6,
	},
	info: {
		marginLeft: 20,
	},
	btn: {
		paddingHorizontal: 10,
		height: 30,
		borderRadius: 9,
	},
	btnLabel: {
		color: "#fff",
		lineHeight: 15,
		height: 30,
	},
});
